module.exports = __webpack_public_path__ + "static/img/edu_pic_01.a36502a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/solution/panels/img/softbox/edu_pic_01.jpg
// module id = Sy+C
// module chunks = 0